import React, { useEffect } from 'react';
import '../styles/case-studies-custom.css';

function CaseStudiesPage() {
  useEffect(() => {
    setTimeout(() => {
      if (window.WOW) {
        try {
          new window.WOW().init();
        } catch (e) {
          console.log('WOW.js not available');
        }
      }
    }, 500);
  }, []);

  const caseStudies = [
    {
      id: 1,
      title: 'Overcoming Anxiety Disorders',
      category: 'Anxiety Management',
      description: 'A comprehensive case study of how cognitive behavioral therapy helped a patient overcome severe anxiety disorder.',
      image: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80',
      client: 'Anonymous Client',
      duration: '6 months',
      outcome: '85% improvement'
    },
    {
      id: 2,
      title: 'Depression Recovery Journey',
      category: 'Depression Treatment',
      description: 'Detailed account of a patient\'s journey from clinical depression to recovery through integrated therapy.',
      image: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80',
      client: 'Anonymous Client',
      duration: '8 months',
      outcome: '90% improvement'
    },
    {
      id: 3,
      title: 'Relationship Counseling Success',
      category: 'Relationship Therapy',
      description: 'How couples therapy helped resolve communication issues and strengthen their relationship.',
      image: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80',
      client: 'Anonymous Couple',
      duration: '4 months',
      outcome: 'Relationship restored'
    },
    {
      id: 4,
      title: 'Career Transition Support',
      category: 'Career Counseling',
      description: 'A professional\'s journey to finding fulfillment through career counseling and life coaching.',
      image: 'https://images.unsplash.com/photo-1454023492550-5696f8ff10e1?auto=format&fit=crop&w=400&q=80',
      client: 'Anonymous Client',
      duration: '3 months',
      outcome: 'Career change successful'
    },
    {
      id: 5,
      title: 'Family Therapy Success',
      category: 'Family Psychology',
      description: 'How family therapy helped resolve generational trauma and improve family dynamics.',
      image: 'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=400&q=80',
      client: 'Anonymous Family',
      duration: '12 months',
      outcome: 'Family harmony achieved'
    },
    {
      id: 6,
      title: 'Teen Mental Health Support',
      category: 'Youth Counseling',
      description: 'Supporting a teenager through academic stress and emotional challenges.',
      image: 'https://images.unsplash.com/photo-1503676382389-4809596d5290?auto=format&fit=crop&w=400&q=80',
      client: 'Anonymous Teen',
      duration: '5 months',
      outcome: '80% improvement'
    }
  ];

  return (
    <>
      {/* Page Header Start */}
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: 'url(/assets/images/backgrounds/slider-2-1.jpg)' }}></div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="page-header__title">Case Studies</h2>
            <ul className="thm-breadcrumb">
              <li><a href="/">Home</a></li>
              <li><span>/</span></li>
              <li><span>Case Studies</span></li>
            </ul>
          </div>
        </div>
      </section>
      {/* Page Header End */}

      {/* Case Studies Section Start */}
      <section className="case-studies-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center wow fadeInUp">
                <span className="section-title__tagline">Success Stories</span>
                <h2 className="section-title__title">Our Case Studies</h2>
              </div>
            </div>
          </div>
          <div className="row">
            {caseStudies.map((study, idx) => (
              <div key={study.id} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${0.1 * idx}s`}>
                <div className="case-study-card">
                  <div className="case-image">
                    <img src={study.image} alt={study.title} />
                  </div>
                  <div className="case-content">
                    <p className="case-category">
                      <span style={{marginRight: 6}}>
                        <i className="fas fa-lightbulb"></i>
                      </span>
                      {study.category}
                    </p>
                    <h3 className="case-title">{study.title}</h3>
                    <p className="case-description">{study.description}</p>
                    <div className="case-details">
                      <div className="case-detail"><strong>Client:</strong> {study.client}</div>
                      <div className="case-detail"><strong>Duration:</strong> {study.duration}</div>
                      <div className="case-detail"><strong>Outcome:</strong> {study.outcome}</div>
                    </div>
                    <a href={`/case-study/${study.id}`} className="thm-btn read-more-btn">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Case Studies Section End */}
    </>
  );
}

export default CaseStudiesPage;
